// helix-exception: Helix has no semantic token for these hues (Figma needs-input orange, highlight yellow/amber, categorical teal/cyan); primitive ramps with the identical colour are used (F-11)
import type { OrderReportResponse } from '@/types/OrderReportTypes'
import { InfoCircle } from 'flowbite-react-icons/outline'

import { formatReportTimestamp } from './reportTimestamp'

/**
 * Warning banner shown when the latest report is critical and not yet
 * acknowledged. Shared by the results page and the guidance page so a provider
 * sees (and can acknowledge) an unreviewed critical result from either view.
 */
export function CriticalResultBanner({
  reports,
  onAcknowledge,
  isConfirming,
}: {
  reports: OrderReportResponse[]
  onAcknowledge: () => void
  isConfirming: boolean
}) {
  return (
    <div
      className="flex w-full flex-col gap-4 rounded-base border border-orange-300 dark:border-orange-700 bg-warning-50 dark:bg-gray-900 p-4"
      role="alert"
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2">
          <InfoCircle className="h-4 w-4 shrink-0 text-orange-700 dark:text-orange-200" />
          <p className="text-lg font-semibold leading-5 tracking-tight text-orange-700 dark:text-orange-200">
            Critical Result
          </p>
        </div>
        <div className="font-sans text-sm font-normal leading-5 text-orange-700 dark:text-orange-200">
          {reports.length === 0 ? (
            <p>Final report was generated. Review and acknowledge within 24 hours.</p>
          ) : (
            reports.map((report) => {
              const ts = formatReportTimestamp(report.generated_at) ?? formatReportTimestamp(report.created_at)
              return (
                <p key={report.id}>
                  Final report was generated{ts ? ` on ${ts}` : ''}. Review and acknowledge within 24 hours.
                </p>
              )
            })
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={onAcknowledge}
        disabled={isConfirming}
        className="inline-flex items-center justify-center gap-1.5 self-start whitespace-nowrap rounded-full bg-orange-500 px-2.5 py-1.5 text-xs font-medium text-white shadow-xs transition-colors hover:opacity-90 disabled:opacity-60"
      >
        {isConfirming ? 'Confirming…' : 'Acknowledge'}
      </button>
    </div>
  )
}

export default CriticalResultBanner
